"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    AR: ['أحد', 'أثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
};
